<template>
  <div class="flex justify-between">
    <div class="flex flex-col">
      <div>
        <span class="uppercase text-sm text-fg-secondary font-label">Tables</span>
        <span
          id="selected-tables-name"
          class="text-lg font-heading font-semibold text-fg-primary block"
        >
          {{ hasSelectedTables ? selectedTablesName : 'No tables selected' }}
        </span>
      </div>
      <span
        id="guest-range"
        class="text-xs font-label"
        :class="!isTotalGuestsWithinRange ? 'text-fg-error' : 'text-fg-secondary'"
      >
        {{ guestRange }}
      </span>
    </div>
    <InputCounter
      id="guest-counter"
      class="pl-6"
      label="Guests"
      :min="1"
      :value="modelValue"
      :disabled="disableCounter"
      @update:value="updateTotalGuests"
    >
      <span id="guest-counter-label" :class="{ 'text-fg-error': !isTotalGuestsWithinRange }">
        {{ modelValue }}
      </span>
    </InputCounter>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, toRefs, watch } from 'vue'

import InputCounter from '@/common/components/molecules/InputCounter.vue'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (event: 'update:modelValue', newCount: number): void
}>()

const props = withDefaults(
  defineProps<{
    disableCounter?: boolean
    modelValue: number
    minGuests: number
    maxGuests: number
  }>(),
  {
    disableCounter: false,
  },
)
const { minGuests, maxGuests, modelValue } = toRefs(props)
const { selectedTablesName, hasSelectedTables } = storeToRefs(usePerformanceReservationStore())
const isTotalGuestsWithinRange = computed<boolean>(() => {
  return modelValue.value >= minGuests.value && modelValue.value <= maxGuests.value
})
const guestRange = computed<string>(() => `${minGuests.value} - ${maxGuests.value} guests`)
watch(guestRange, function () {
  if (!isTotalGuestsWithinRange.value) updateTotalGuests(maxGuests.value)
})
function updateTotalGuests(newCount: number) {
  if (newCount >= 0) {
    emit('update:modelValue', newCount)
  }
}
</script>
